import React, { Component } from 'react';

import TinyNodeParkinglocationsSelect from './TinyNodeParkinglocationsSelect';

import GoogleMap from './GoogleMap';

import { Form, Input, Button, Modal, InputNumber, Select } from 'antd';
const FormItem = Form.Item;

class TinyNodeInfrastructuresForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const fullFormItemLayout = {
      labelCol: {
        xs: { span: 0 },
        sm: { span: 0 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Druh" >
          {getFieldDecorator('kind', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Select
              placeholder={"Zvolte druh"}
              onChange={(value) => {
                this.props.form.setFieldsValue({ kind: value });
              }}>
              <Select.Option value="R">Repeater</Select.Option>
              <Select.Option value="GW">Gateway</Select.Option>
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Lokalita" >
          {getFieldDecorator('parkingLocationId', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <TinyNodeParkinglocationsSelect onChange={(value) => { this.props.form.setFieldsValue({ parkingLocationId: value }); }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="NodeID" >
          {getFieldDecorator('nodeID', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={1} max={9999999} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Z. šířka" >
          {getFieldDecorator('latitude', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={1} max={9999999} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Z. výška" >
          {getFieldDecorator('longitude', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={1} max={9999999} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Popis" >
          {getFieldDecorator('description', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }],
          })(
            <Input.TextArea rows={3} />
          )}
        </FormItem>
        {/* <FormItem
          {...fullFormItemLayout}
          label="Umístění" >
          {getFieldDecorator('Definition', {
            rules: [{
              type: 'object', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <GoogleMap
              drawingManagerEnabled={true}
              onMarkerChanged={(coordinates) => {
                console.log(coordinates);
                // let definition = {
                //   coordinates: [],
                //   type: 'Point'
                // }
                // definition.coordinates = coordinates;
                // this.props.form.setFieldsValue({
                //   RoadSignDefinition: definition
                // });
              }} />
          )}
        </FormItem> */}
        {this.props.type && this.props.type !== 'modal'
          ? <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Uložit</Button>
          </FormItem>
          : null}
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          className={'cstm-modal-form'}
          width={700}
          title="Vytvoření nového prvku infrastruktury"
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          okText="Uložit"
          onOk={this.handleSubmit}>
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(TinyNodeInfrastructuresForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/TinyNodeInfrastructuresForm.js